import { alpha, Box, useTheme } from '@rossum/ui/material';
import { DiffCell, DiffSegment } from './computeDiffRows';

type LineCellProps = {
  cell: DiffCell | null;
  // null for context rows
  emphasis: 'removed' | 'added' | null;
  divider?: boolean;
};

// Character offset of each segment within its line, used as a stable key.
const withOffsets = (segments: DiffSegment[]) => {
  let offset = 0;
  return segments.map(segment => {
    const withOffset = { ...segment, offset };
    offset += segment.text.length;
    return withOffset;
  });
};

// A line-number cell and a text cell, placed directly into the viewer grid.
export const LineCell = ({
  cell,
  emphasis,
  divider = false,
}: LineCellProps) => {
  const theme = useTheme();

  const emphasisColor =
    emphasis === 'removed'
      ? theme.palette.error.main
      : theme.palette.success.main;
  const rowBg =
    emphasis === null
      ? undefined
      : cell === null
        ? theme.palette.action.hover
        : alpha(emphasisColor, 0.08);
  const segmentBg = alpha(emphasisColor, 0.3);

  return (
    <>
      <Box
        component="span"
        sx={{
          px: 1,
          textAlign: 'right',
          userSelect: 'none',
          color: 'text.disabled',
          bgcolor: rowBg,
          borderLeft: divider ? 1 : 0,
          borderColor: 'divider',
        }}
      >
        {cell?.lineNumber ?? ''}
      </Box>
      <Box
        component="span"
        sx={{
          px: 1,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          bgcolor: rowBg,
        }}
      >
        {withOffsets(cell?.segments ?? []).map(segment => (
          <Box
            key={segment.offset}
            component="span"
            sx={{
              bgcolor: segment.highlighted ? segmentBg : undefined,
            }}
          >
            {segment.text}
          </Box>
        ))}
      </Box>
    </>
  );
};
